import React from 'react';
import { Alert, Button, Container, Col, Row } from 'reactstrap';
import HostsSidebar from './HostsSidebar';
import ServicesSidebar from './ServicesSidebar';
import DataCenters from './DataCenters';
import Breadcrumbs from '../Breadcrumb';
import Spinner from '../Spinner/Spinner';

const prioritizeDataCenter = dataCenter => {
  switch (dataCenter.name) {
    case 'Los Angeles':
      return 2;
    case 'Chicago':
      return 1;
    default:
      return 0;
  }
};

const Infrastructure = () => {
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [dataCenters, setDataCenters] = React.useState([]);
  const onError = e => {
    setDataCenters(false);
    setErrorMessage(e.name === 'AbortError' ? 'Monitoring service is unreachable' : e.message);
  };
  const getHosts = () => {
    try {
      setDataCenters([]);
      setErrorMessage(null);
      const url = process.env?.REACT_APP_INFRASTRUCTURE_MONITORING_URL;
      if (url === undefined) {
        throw new Error(`Environment is missing infrastructure monitoring URL`);
      }
      const controller = new AbortController();
      const fetchTimeoutId = setTimeout(() => controller.abort(), 5000);
      fetch(url, { signal: controller.signal })
        .then(response => {
          clearTimeout(fetchTimeoutId);
          if (!response?.ok) throw new Error(response?.status);
          return response.json();
        })
        .then(json =>
          setDataCenters(json.sort((a, b) => prioritizeDataCenter(a) < prioritizeDataCenter(b))),
        )
        .catch(onError);
    } catch (e) {
      onError(e);
    }
  };
  React.useEffect(getHosts, []);
  return (
    <div style={{ textAlign: 'left' }}>
      <div className="filter-section" style={{ marginTop: 6 }}>
        <Row>
          {/* <Col md={4} sm={12}>
            <Breadcrumbs />
          </Col> */}
          <Col className="d-flex justify-content-end" style={{ textAlign: 'right' }}>
            <Button
              type="button"
              color="primary"
              outline
              size="sm"
              onClick={getHosts}
              disabled={dataCenters?.length === 0}
            >
              Refresh
            </Button>
          </Col>
        </Row>
      </div>
      <Container style={{ marginTop: 10, marginBottom: 40 }}>
        <Row>
          <Col style={{ backgroundColor: '#f4f4f4' }}>
            {dataCenters.length > 0 && (
              <Container>
                <Row>
                  <Col sm="auto" style={{ marginRight: 10 }}>
                    <Row sm="auto" style={{ marginBottom: 10 }}>
                      <HostsSidebar dataCenters={dataCenters} />
                    </Row>
                    <Row sm="auto" style={{ marginBottom: 10 }}>
                      <ServicesSidebar dataCenters={dataCenters} />
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <DataCenters dataCenters={dataCenters} />
                    </Row>
                  </Col>
                </Row>
              </Container>
            )}
            {dataCenters?.length === 0 && (
              <Spinner text={null} customText="Checking infrastructure" />
            )}
            <Alert color="danger" isOpen={errorMessage} toggle={() => setErrorMessage(null)}>
              {errorMessage}
            </Alert>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Infrastructure;
